import { bindable, inject } from 'aurelia';

@inject(Element)
export class InlineEditText {
    @bindable public value: string = '';
    @bindable public isEditing: boolean = false;
    @bindable public placeholderText: string = '';
    @bindable public inputClass: string = '';
    @bindable public disabled: boolean = false;
    @bindable public allowEmpty: boolean = false;

    public draftValue: string = '';
    public editInput: HTMLInputElement = null;

    private readonly _element: Element;

    constructor(element: Element) {
        this._element = element;
    }

    public bound(): void {
        if (this.isEditing) {
            this.draftValue = this.value ?? '';
            this._focusInput();
        }
    }

    public isEditingChanged(newValue: boolean): void {
        if (newValue) {
            this.draftValue = this.value ?? '';
            this._focusInput();
        }
    }

    public get hasText(): boolean {
        return (this.value ?? '').trim().length > 0;
    }

    public startEdit(): void {
        if (this.disabled) { return; }
        this.isEditing = true;
    }

    public saveEdit(): void {
        this.value = (this.draftValue ?? '').trim();
        this._element.dispatchEvent(new CustomEvent('save-edit', {
            detail: { value: this.value },
            bubbles: true
        }));
        this.isEditing = false;
    }

    public cancelEdit(): void {
        this.draftValue = this.value ?? '';
        this.isEditing = false;
        this._element.dispatchEvent(new CustomEvent('cancel-edit', { bubbles: true }));
    }

    private _focusInput(): void {
        setTimeout(() => {
            this.editInput?.focus();
            this.editInput?.select();
        }, 0);
    }
}
